export enum StorageName {
  cookieConsentStatus = "cookieconsent_status",
  analytics = "analyticsCookies",
  retargeting = "retargetingCookies",
}
